module.exports = __webpack_public_path__ + "static/media/1demo.e6e5356d.svg";